import { domScheduler } from "@studiometa/js-toolkit/utils";
import { fallbackStore as store } from "../utils/storage/index.js";
const key = "theme";
const themes = /* @__PURE__ */ new Set(["dark", "light"]);
const defaultTheme = "light";
async function getTheme() {
  return await store.get(key) || defaultTheme;
}
async function themeIsDark() {
  return await getTheme() === "dark";
}
async function themeIsLight() {
  return await getTheme() === "light";
}
async function themeUpdateDOM(value) {
  const theme = value ?? await getTheme();
  domScheduler.write(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  });
}
async function setTheme(value) {
  let theme = value ?? await getTheme();
  if (!themes.has(theme)) {
    console.warn(`The "${theme}" theme is not valid.`);
    theme = defaultTheme;
  }
  store.set(key, theme);
  themeUpdateDOM(theme);
}
function watchTheme(callback) {
  return store.watch((k, newValue) => k === key && callback(newValue));
}
export {
  getTheme,
  setTheme,
  themeIsDark,
  themeIsLight,
  themeUpdateDOM,
  watchTheme
};
//# sourceMappingURL=theme.js.map
